import APIJWT from "./APIJWT.js"
import AuthEvent from "./AuthEvent.js"

export default class APIUser {

    logOut() {
        
        window.localStorage.removeItem(
            this.jwtKey
        )
        
        delete this.apiJWT
        AuthEvent.logout()
    }

    isSoftLoggedIn() {

        if(!this.apiJWT) {
            AuthEvent.logout()
            return false
        }

        if (!this.apiJWT.isHardValid()) {

            this.logOut()
            return false
        }

        AuthEvent.login(this)
        return true
    }

    isLoggedIn() {
        return (
            this.isSoftLoggedIn() 
            && this.apiJWT.isValid()
        )
    }

    getUser() {
        if(this.isSoftLoggedIn()) {
            return this.apiJWT.body
        }
    }

    hasRole(pRole) {
        if(this.isSoftLoggedIn()) {
            return this.apiJWT.hasRole(pRole)
        }
    }

    getAuthHeader() {
        if(this.isSoftLoggedIn()) {
            return (
                "Bearer "
                + this.apiJWT.jwt
            ) 
        }
    }

    getJWT() {
        if(this.isSoftLoggedIn()) {
            return this.apiJWT.jwt
        }
    }

    logIn(pJWT) {

        this.logOut()
        const jwt = new APIJWT(pJWT)

        if(jwt.isValid()) {
            
            window.localStorage.setItem(
                this.jwtKey, 
                pJWT
            )

            this.apiJWT = jwt
            AuthEvent.login(this)
            return true
        }
    }

    constructor(p) {

        this.jwtKey = p.jwtKey
        const jwt = window.localStorage.getItem(
            this.jwtKey
        )

        if (!jwt || (jwt === "undefined")) {
            
            this.logOut()
            return
        }

        this.apiJWT = new APIJWT(jwt)
        this.isSoftLoggedIn()
    }
}